import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  comutaValoareFiltruRapid,
  seteazaFiltruRapid,
  stergeFiltreleRapide,
  valoriFiltruRapid,
} from "@/utils/targetareFiltreRapide";
import {
  valoriDistincte,
  type FiltruRapidDef,
  type FiltruRaport,
} from "@/utils/targetareRaport";
import type { RandRaport } from "@/utils/targetareTabel";
import { FiltruRapid } from "./FiltruRapid";

type FiltreRapideProps<R extends RandRaport> = {
  definitii: FiltruRapidDef[];
  randuri: R[];
  filtre: FiltruRaport[];
  onFiltre: (filtre: FiltruRaport[]) => void;
};

export function FiltreRapide<R extends RandRaport>({
  definitii,
  randuri,
  filtre,
  onFiltre,
}: FiltreRapideProps<R>) {
  const areVreunul = definitii.some(
    (d) => valoriFiltruRapid(filtre, d.coloana).length > 0
  );
  return (
    <div className="flex flex-wrap items-center gap-2 border-x border-b px-3 py-2">
      <span className="text-xs uppercase tracking-wide text-muted-foreground">
        Filtre
      </span>
      {definitii.map((def) => (
        <FiltruRapid
          key={def.coloana}
          def={def}
          optiuni={def.optiuni ?? valoriDistincte(randuri, def.coloana)}
          valori={valoriFiltruRapid(filtre, def.coloana)}
          onComuta={(v) =>
            onFiltre(comutaValoareFiltruRapid(filtre, def.coloana, v))
          }
          onGoleste={() =>
            onFiltre(seteazaFiltruRapid(filtre, def.coloana, []))
          }
        />
      ))}
      {areVreunul && (
        <Button
          variant="ghost"
          size="sm"
          className="h-8"
          onClick={() => onFiltre(stergeFiltreleRapide(filtre))}
        >
          <X className="mr-1 h-3 w-3" />
          Șterge filtrele
        </Button>
      )}
    </div>
  );
}
